import { CardWrapperProps } from "./types";
import CardSkeleton from "../CardSkeleton/CardSkeleton";
import DataLoadError from "../DataLoadError";

const CardWrapper = <T extends { id: string }>({
  items,
  skeletonCount = 1,
  currentBrandId,
  component: Component,
  loading,
  error,
  onRetry,
  onUpgrade,
}: CardWrapperProps<T>) => {
  const renderSkeletons = () => {
    return Array.from({ length: skeletonCount }).map((_, index) => (
      <CardSkeleton key={index} />
    ));
  };

  if (loading) return renderSkeletons();

  if (!items && error) {
    return (
      <DataLoadError
        message={error}
        onRetry={onRetry}
      />
    );
  }

  if (!items) return renderSkeletons();

  return (
    <div>{ items.map((item) => (
      <Component
        key={item.id}
        onUpgrade={onUpgrade}
        item={item}
        currentBrandId={currentBrandId}
      />
    )) }</div>
  );
};

export default CardWrapper;